<script module>
    export const PHONE_REGEX = /\+?[\d\s\-/()]{6,}/;
</script>

<script>
    import {paymentStore} from '$lib/paymentStore.svelte.js';
    import {store as userStore} from '$lib/userStore.svelte.js';
    import PhoneBlock from '$component/PhoneBlock.svelte';

    let {
        onchange = (_state) => {},
    } = $props();

    const selectedShipping = $derived(
        (paymentStore.shippingMethods ?? []).find(s => s.shippingSet?.id === paymentStore.selectedShippingId)
    );
    // Phone is required strictly by the SELECTED shipping method's flag — same
    // rule for every payment incl. PayPal Express. The old express-mode "any
    // available method requires phone" shortcut wrongly showed the field for
    // DHL / Selbstabholung whenever a phone-requiring method (e.g. Emons) was
    // merely in the list. Switching shipping re-derives this reactively.
    const requiresPhone = $derived(
        !!selectedShipping?.shippingSet?.requiresPhone
    );

    let phone = $state('');
    let phonePrefilled = $state(false);

    $effect(() => {
        if (phonePrefilled) return;
        const storePhone = userStore.user?.billingAddress?.phone
            ?? userStore.user?.shippingAddress?.phone
            ?? '';
        if (storePhone) {
            phone = storePhone;
            phonePrefilled = true;
        }
    });

    const phoneOk = $derived(!requiresPhone || PHONE_REGEX.test(phone));

    $effect(() => { onchange({requiresPhone, phone, phoneOk}); });
</script>

{#if requiresPhone}
    <PhoneBlock bind:phone prefilled={phonePrefilled} />
{/if}
